import { useLocation } from 'react-router-dom';

const useDefaultDateRange = () => {
  const location = useLocation();

  const isIncidentsPage = location.pathname.includes('/incidents');

  return isIncidentsPage ? 3 : 7;
};

export default useDefaultDateRange;
